import { useEffect, useRef } from "react";
import { useGoogleMap } from "@ubilabs/google-maps-react-hooks";
import { crearInput, crearBotonBuscar, crearBotonBuscarArea, crearControlDiv, buscarPlaces } from "./buscadorLugaresMap";

export const BuscadorLugares = ({ setLatLng }) => {
  const map = useGoogleMap();
  const markersRef = useRef([]);
  const infoWindowRef = useRef(null);
  const lastQueryRef = useRef("");
  const inputRef = useRef(null);
  const buscarAreaBtnRef = useRef(null);
  const queryRef = useRef("");
  const buscarRef = useRef(null);

  buscarRef.current = (usarBounds) => {
    const query = inputRef.current?.value || queryRef.current;
    lastQueryRef.current = query;
    buscarPlaces({ map, query, usarBounds, markersRef, infoWindowRef, buscarAreaBtnRef, setLatLng });
  };

  useEffect(() => {
    if (!map) return;

    const input = crearInput({
      onEnter: () => buscarRef.current(false),
      onInput: (val) => { queryRef.current = val; },
    });
    inputRef.current = input;

    const btn = crearBotonBuscar(() => buscarRef.current(false));

    const areaBtn = crearBotonBuscarArea(() => {
      areaBtn.style.display = "none";
      buscarRef.current(true);
    });
    buscarAreaBtnRef.current = areaBtn;

    const controlDiv = crearControlDiv();
    controlDiv.appendChild(input);
    controlDiv.appendChild(btn);
    controlDiv.appendChild(areaBtn);
    map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(controlDiv);

    return () => {
      map.controls[window.google.maps.ControlPosition.TOP_CENTER].clear();
    };
  }, [map]);

  useEffect(() => {
    if (!map) return;
    const listener = map.addListener("dragend", () => {
      if (lastQueryRef.current && buscarAreaBtnRef.current) {
        buscarAreaBtnRef.current.style.display = "block";
      }
    });
    return () => window.google.maps.event.removeListener(listener);
  }, [map]);

  return null;
};
